import { ReactElement, useState } from 'react'

import styled from 'styled-components'
import { Cancel } from '@mui/icons-material'
import { Button } from '../../../../ui-components/forms/Button'
import { SimpleModal } from '../../../../ui-components/modals/SimpleModal'
import { I18n, Translate } from 'common'
import { useNavigate, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useSearchStore } from '../../../../store/search/SearchStore'
import { breakpoints } from '../../../../theme/breakpoints'
import {
  useVehicleWidgetStore,
  VehicleWidgetDisplayState,
} from '../../VehicleSearch/store/VehicleWidgetStore'
import { usePartsCatalog } from '../../../../store/partsCatalog/PartsCatalog'
import { Button as ButtonV2 } from '../../../../ui-components/forms/ButtonV2'

interface EditControlsProps {
  onConfirm: () => void
  onCancel: () => void
  onClearSelections: () => void
  updateDisabled: boolean
}
export const EditControls = observer(
  (props: EditControlsProps): ReactElement => {
    const { onConfirm, onCancel, onClearSelections, updateDisabled } = props
    const [showConfirm, setShowConfirm] = useState(false)
    const { clearStore } = usePartsCatalog()
    const navigate = useNavigate()
    const location = useLocation()
    const handleUpdate = () => {
      if (location.pathname.indexOf('partsCatalog') > -1) {
        onConfirm()
      } else {
        setShowConfirm(true)
      }
    }
    const vehicleWidgetStore = useVehicleWidgetStore()

    const searchStore = useSearchStore()

    const handleDeleteVehicle = () => {
      searchStore.deleteCurrentVehicle()
      vehicleWidgetStore.setDisplayState(VehicleWidgetDisplayState.select)
      vehicleWidgetStore.setIsDrawerOpened(false)
    }

    return (
      <>
        <Wrapper>
          <Controls>
            <ClearSelections onClick={onClearSelections}>
              <Cancel style={{ fontSize: '18px', margin: 'auto' }} />
              <I18n name="clearSelections" />
            </ClearSelections>
            <ButtonDesktop onClick={onCancel} variant="secondary" size="large">
              <span>
                {Translate('cancel')}
                <I18n name="vehicle" style={{ display: 'none' }} />
              </span>
            </ButtonDesktop>
            <ButtonDesktop
              onClick={handleUpdate}
              size="large"
              disabled={updateDisabled}
            >
              <I18n name="update" />
            </ButtonDesktop>

            <ButtonMobile
              onClick={handleDeleteVehicle}
              text="deleteVehicle"
              variant="secondary"
              size="large"
            />
            <ButtonMobile
              onClick={handleUpdate}
              text="save"
              size="large"
              disabled={updateDisabled}
            />
          </Controls>
        </Wrapper>
        <SimpleModal
          show={showConfirm}
          title="updateVehicle"
          onSecondaryAction={onCancel}
          onPrimaryAction={() => {
            onConfirm()
            clearStore()
            navigate('/partsCatalog')
          }}
          secondaryActionText="cancel"
          primaryActionText="update"
        >
          updatingYourVehicleWillChangeSearch
        </SimpleModal>
      </>
    )
  }
)

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  @media screen and (max-width: ${breakpoints.tabletXLarge}px) {
    justify-content: center;
  }
`

const ButtonDesktop = styled(ButtonV2)`
  @media screen and (max-width: ${breakpoints.tabletXLarge}px) {
    display: none;
  }
`

const ButtonMobile = styled(Button)`
  display: none;
  @media screen and (max-width: ${breakpoints.tabletXLarge}px) {
    display: block;
    width: 100%;
  }
`

const Controls = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 20px;
  margin-right: 20px;

  @media screen and (max-width: ${breakpoints.tabletXLarge}px) {
    flex-direction: column;
    margin: 16px 0px 0px 0px;
    width: 100%;
  }
`

const ClearSelections = styled.div`
  display: flex;
  gap: 4px;
  color: ${(p) => p.theme.colors.red};
  cursor: pointer;
  @media screen and (max-width: ${breakpoints.tabletXLarge}px) {
    display: none;
  }
`
